package com.gsb.vyapar.bhagya.presentation.category.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.common.image.CategoryPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite

@Composable
fun CategoriesView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        CategoryGrid(uiState, onTriggerEvent)
    }
}

@Composable
fun CategoryGrid(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    LazyVerticalGrid(
        columns = GridCells.Adaptive(minSize = if (uiState.isPortrait) 120.dp else 170.dp),
        modifier = Modifier.fillMaxWidth().padding(4.dp)
    ) {
        if (uiState.isPortrait) {
            items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                Card(
                    modifier = Modifier.width(120.dp).height(120.dp).padding(4.dp),
                    shape = RoundedCornerShape(8.dp),
                    backgroundColor = offwhite,
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center,
                        modifier = Modifier.clickable {
                            onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.ShowCategory(category)))
                        }
                    ) {
                        CategoryPlaceHolder(category.id.toInt())
                        Text14RegularB(text = category.name, color = black)
                    }
                }
                Spacer(Modifier.height(8.dp))
            }
        } else {
            items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                Card(
                    modifier = Modifier.width(170.dp).height(170.dp).padding(4.dp),
                    shape = RoundedCornerShape(8.dp),
                    backgroundColor = offwhite,
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Center,
                        modifier = Modifier.clickable {
                            onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.ShowCategory(category)))
                        }
                    ) {
                        CategoryPlaceHolder(category.id.toInt(), 100.dp, 100.dp)
                        Text14RegularB(text = category.name, color = black)
                    }
                }
                Spacer(Modifier.height(8.dp))
            }
        }
    }
}
